export function GlobalTauriModals() {
  return null;
}
